import { Project, Estimate } from '../../model/types/tasks';

export const getUpdatedProjectsForFilter = (
    projectId: number | null,
    estimateId: number | null,
    projectsForFilter: Project[],
    projects: Project[]
): Project[] | null => {
    if (!projectId) {
        return null;
    }

    const projectIdNum = Number(projectId);

    const existingProjectIds = projectsForFilter.map((project) => Number(project.id));
    const existingEstimateIds = projectsForFilter.flatMap((project) =>
        project.estimates.map((estimate) => Number(estimate.id))
    );

    if (!!estimateId) {
        const estimateIdNum = Number(estimateId);

        if (existingEstimateIds.includes(estimateIdNum)) {
            return null;
        }

        const allEstimates: Estimate[] = projects.flatMap((project) => project.estimates);
        const foundEstimate = allEstimates.find(
            (estimate) => Number(estimate.id) === estimateIdNum
        );

        if (existingProjectIds.includes(projectIdNum)) {
            return projectsForFilter.map((project) => {
                if (Number(project.id) !== projectIdNum) {
                    return project;
                }
                return {
                    ...project,
                    estimates: [...project.estimates, foundEstimate],
                };
            });
        }

        const foundProject = projects.find((project) => Number(project.id) === projectIdNum);

        const { estimates, ...restProjectData } = foundProject;
        const newProject: Project = {
            ...restProjectData,
            estimates: [foundEstimate],
        };

        return [...projectsForFilter, newProject];
    }

    const foundProject = projects.find((project) => Number(project.id) === projectIdNum);

    const { estimates, ...restProject } = foundProject;
    const newProject: Project = {
        ...restProject,
        estimates: [],
    };

    return [...projectsForFilter, newProject];
};
